import React from 'react'

export const PinIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="13"
    height="16"
    viewBox="0 0 13 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 6.60007C12 10.0952 8.19194 13.7353 6.91319 14.8595C6.79406 14.9507 6.64905 15 6.5 15C6.35095 15 6.20594 14.9507 6.08681 14.8595C4.80806 13.7353 1 10.0952 1 6.60007C1 5.11484 1.57946 3.69044 2.61091 2.64022C3.64236 1.59001 5.04131 1 6.5 1C7.95869 1 9.35764 1.59001 10.3891 2.64022C11.4205 3.69044 12 5.11484 12 6.60007Z"
      stroke="#292624"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.5 8.7001C7.63909 8.7001 8.5625 7.75988 8.5625 6.60007C8.5625 5.44026 7.63909 4.50004 6.5 4.50004C5.36091 4.50004 4.4375 5.44026 4.4375 6.60007C4.4375 7.75988 5.36091 8.7001 6.5 8.7001Z"
      stroke="#292624"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
